import { PermissionEnum } from '@Application/Security/Roles';
import EmptyState from '@Guidelines/Component/EmptyState';
import CostSummary from '@UI/Pages/Administration/AiCosts/CostSummary';
import CostTabs from '@UI/Pages/Administration/AiCosts/CostTabs';
import AiCostLimitSidebar from '@UI/Pages/Administration/Shared/Sidebars/AiCostLimitSidebar';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import useStrictAuthenticatedUser from '@UI/Providers/AuthenticatedUserProvider/useStrictAuthenticatedUser';
import { css } from '@emotion/react';
import { Building2 } from 'lucide-react';
import type * as React from 'react';

const contentStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

/**
 * Lays out the total and the tabs (which carry the filter card) for the user's account. Each of them
 * owns its own read, so a request is only made for what is shown. The limit form is mounted for those
 * who may write limits; the readers of the screen load what it needs.
 */
const AiCostsContent: React.FC = () => {
	const { user } = useStrictAuthenticatedUser();
	const accountId = user.account?.id ?? null;

	if (accountId === null) {
		return (
			<EmptyState title="Aucun compte n'est rattaché à votre profil." icon={<Building2 size={28} />} />
		);
	}

	return (
		<div css={contentStyle}>
			<CostSummary accountId={accountId} />
			<CostTabs accountId={accountId} />
			<WithPermission permission={PermissionEnum.AI_COST_LIMIT_WRITE}>
				<AiCostLimitSidebar accountId={accountId} />
			</WithPermission>
		</div>
	);
};

export default AiCostsContent;
